import {
  getFontCss,
  Popup,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import { ButtonDesigns } from 'src/components/Button/Button'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import Trns from 'src/localization/Trns'
import { createSetIsDeleteExpenseReportsPopupOpen } from 'src/redux/actions/app.actions'
import { deleteExpenseReports } from 'src/redux/actions/data/expenses.actions'
import {
  selectDeleteExpenseReportsTopLevelError,
  selectDeletingExpenseReports,
  selectSelectedDeleteExpenseReportsFromState,
} from 'src/redux/selectors/data/expenses.selectors'
import { css } from 'styled-components'

const DeleteExpenseReportsPopup: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch()
  const expenseReports = useSelector(
    selectSelectedDeleteExpenseReportsFromState,
  )
  const deletingExpenseReports = useSelector(selectDeletingExpenseReports)
  const deletingExpenseReportsTopLevelError = useSelector(
    selectDeleteExpenseReportsTopLevelError,
  )
  const { analytics } = useAnalyticsContext()

  const subTitleTopText =
    expenseReports !== undefined &&
    (expenseReports.length === 1 ? (
      <Trns source={'You are about to delete 1 report.'} />
    ) : (
      <Trns
        source={'You are about to delete ${count} reports.'}
        expressions={{
          count: expenseReports.length.toString(),
        }}
      />
    ))

  const dispatchDeleteExpenseReports = (): void => {
    expenseReports !== undefined &&
      dispatch(deleteExpenseReports(expenseReports, analytics))
  }

  const closePopup = (): void => {
    dispatch(createSetIsDeleteExpenseReportsPopupOpen(false))
  }

  return (
    <Popup
      onClickClose={closePopup}
      showCloseButton
      css={`
        display: flex;
        flex-direction: column;
        position: relative;
      `}
    >
      <ConfirmationPopupContent
        title={
          expenseReports?.length === 1 ? (
            <Trns source={'Delete Report'} />
          ) : (
            <Trns source={'Delete Reports'} />
          )
        }
        subtitle={
          <>
            <p
              css={css`
                margin-bottom: 20px;
              `}
            >
              {subTitleTopText}
            </p>
            <p
              css={css`
                ${getFontCss(
                  16,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              <Trns source={'This action cannot be undone.'} />
            </p>
          </>
        }
        actionButtonLabel={<Trns source={'Confirm and Delete'} />}
        actionButtonOnClick={dispatchDeleteExpenseReports}
        actionButtonLoading={deletingExpenseReports}
        actionButtonDesign={ButtonDesigns.designRed}
        topLevelError={deletingExpenseReportsTopLevelError}
        isCancelButtonLink
        underline={false}
        cancelButtonOnClick={closePopup}
        cancelButtonLabel={<Trns source={'Cancel'} />}
      />
    </Popup>
  )
}

export default DeleteExpenseReportsPopup
